export const MAX_RETURN_CANCEL_DEADLINE_DAYS = 60

export const exchangeOrdersAutomaticCreationValues = {
  automatic: 'automatic',
  manual: 'manual',
}
